import { createBrowserHistory } from "history";

export const history = createBrowserHistory({
    basename: import.meta.env.BASE_URL,
});

// Для дебага переходов
// history.listen((location, action) => {
//     console.trace()
//     console.log(`The current URL is ${location.pathname}${location.search}${location.hash}`);
//     console.log(`The last navigation action was ${action}`);
// });

export const routeInformation = {
    getServer: () =>
        /server\/([0123456789ABCDEFGHJKMNPQRSTVWXYZ]{26})/.exec(
            history.location.pathname,
        )?.[1],
    getChannel: () =>
        /channel\/([0123456789ABCDEFGHJKMNPQRSTVWXYZ]{26})/.exec(
            history.location.pathname,
        )?.[1],
};
